export default "__VITE_ASSET__hiFOoZLf__"